import axios from "axios";
import {
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_SAVE_SHIPPING_ADDRESS,
  CART_SAVE_SALES_PROGRAM,
  CART_SAVE_SALES_PROGRAM_GROUP,
  CART_SAVE_ADJUSTMENTS,
  CART_SAVE_CONFIGURE,
} from "../constants/cartConstants";


export const addToCart = (id, qty, tractors, attachments, options, salesProgramGroup) => async (dispatch, getState) => {
  try {
      const { userLogin: { userInfo } } = getState();
      const config = userInfo ? {
          headers: {
              'Content-type': 'application/json',
              Authorization: `Bearer ${userInfo.token}`,
          },
      } : {};

      // Using Axios with config for potentially authorized request
      const { data } = await axios.get(`/api/products/${id}`, config);

      dispatch({
          type: CART_ADD_ITEM,
          payload: {
          product: data._id,
          name: data.name,
          short_description: data.short_description,
          image: data.image,
          qty,
          tractors,
          attachments,
          options,
          salesProgramGroup,
          },
      });

      // Update local storage
      localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
  } catch (error) {
      console.error('Error adding to cart:', error.message);
      // You might want to handle this error differently, perhaps by dispatching an error action.
  }
};


export const removeFromCart = (id) => (dispatch, getState) => {
  dispatch({
    type: CART_REMOVE_ITEM,
    payload: id,
  });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

export const saveShippingAddress = (data) => (dispatch) => {
  dispatch({
    type: CART_SAVE_SHIPPING_ADDRESS,
    payload: data,
  });

  localStorage.setItem("shippingAddress", JSON.stringify(data));
};

export const saveSalesPrograms = (data) => (dispatch) => {
  dispatch({
    type: CART_SAVE_SALES_PROGRAM,
    payload: data,
  });

  localStorage.setItem("salesProgram", JSON.stringify(data));
}

export const saveSalesProgramGroup = (data) => (dispatch) => {
  dispatch({
    type: CART_SAVE_SALES_PROGRAM_GROUP,
    payload: data,
  });

  localStorage.setItem("salesProgramGroup", JSON.stringify(data));
}

export const saveConfigure = (data) => (dispatch) => {
  dispatch({
    type: CART_SAVE_CONFIGURE,
    payload: data,
  });

  localStorage.setItem("configure", JSON.stringify(data));
}

export const saveAdjustments = (data) => (dispatch) => {
  dispatch({
    type: CART_SAVE_ADJUSTMENTS,
    payload: data,
  });

  localStorage.setItem("adjustments", JSON.stringify(data));
}

